module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp12_7.1d9eabb1.png";